import { OrderModel } from "../../models/orders/order-list-model";
import * as XLSX from 'xlsx';
import { getFlagReasonsByCustomer } from "../../utils/flag-reason";

export const orderExport = (orderList : OrderModel[]) => {
    const orderData = orderWiseData(orderList);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);

    ws['B'] = { t: 's', v: 'Total Value', s: { font: { bold: true } } };
    ws['C'] = { t: 's', v: 'Handling charges', s: { font: { bold: true } } };
    ws['D'] = { t: 's', v: 'Courier charges', s: { font: { bold: true } } };
    ws['E'] = { t: 's', v: 'Packing charges', s: { font: { bold: true } } };
    ws['F'] = { t: 's', v: 'Payment gateway charges', s: { font: { bold: true } } };
    
    for (let r = 2; r <= orderData.length + 1; r++) {
        const cellTotal = `B${r}`;
        const cellHandling = `C${r}`;
        const cellCourier = `D${r}`;
        const cellPacking = `E${r}`;
        const cellPaymentGateway = `F${r}`;
        const formattedTotal = `${orderData[r - 2].Total_Value.toFixed(2)}`;
        const formattedHandling = `${orderData[r - 2].Handling_charges.toFixed(2)}`;
        const formattedCourier = `${orderData[r - 2].Courier_charges.toFixed(2)}`;
        const formattedPacking = `${orderData[r - 2].Packing_charges.toFixed(2)}`;
        const formattedPaymentGC = `${orderData[r - 2].Payment_gateway_charges.toFixed(2)}`;
        ws[cellTotal] = { t: 'n', v: formattedTotal, z: '#,##0.00' };
        ws[cellHandling] = { t: 'n', v: formattedHandling, z: '#,##0.00' };
        ws[cellCourier] = { t: 'n', v: formattedCourier, z: '#,##0.00' };
        ws[cellPacking] = { t: 'n', v: formattedPacking, z: '#,##0.00' };
        ws[cellPaymentGateway] = { t: 'n', v: formattedPaymentGC, z: '#,##0.00' };;
    }
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'OrderListExport.xlsx');
}

const orderWiseData = (orderList : OrderModel[]) => {
    var flatData: any = [];
    orderList?.forEach((order) => {                
        flatData.push({
            'Order#': order.orderID,
            'Total_Value': Math.round(order.taxableAmount + order.taxAmount),
            'Handling_charges': 0,
            'Courier_charges': order.courierCharges,
            'Packing_charges': 0,
            'Payment_gateway_charges': 0
        })        
    });
    return flatData;
}

export const detailExport = async (orderList : OrderModel[]) => {
    const flagReasons = await getFlagReasonsByCustomer(orderList.map(o => o.customerID));
    const itemsData = itemWiseData(orderList, flagReasons);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(itemsData);

    ws['W'] = { t: 's', v: 'Price', s: { font: { bold: true } } };
    ws['AB'] = { t: 's', v: 'Amount', s: { font: { bold: true } } };
    ws['AC'] = { t: 's', v: 'Tax %', s: { font: { bold: true } } };
    ws['AD'] = { t: 's', v: 'Tax Amount', s: { font: { bold: true } } };
    ws['AE'] = { t: 's', v: 'Gross Amount', s: { font: { bold: true } } };
    
    for (let r = 2; r <= itemsData.length + 1; r++) {
    const cellPrice = `W${r}`;
    const cellAmount = `AB${r}`;
    const cellTaxPr = `AC${r}`;
    const cellTaxAmt = `AD${r}`;
    const cellGross = `AE${r}`;
    const cellHC = `AF${r}`;
    const cellPC = `AG${r}`;
    const cellCC = `AH${r}`;
    const cellPGC = `AI${r}`;
    const cellInvAmt = `AJ${r}`;
    const cellInvTax = `AK${r}`;
    const cellInvTotal = `AL${r}`;
    const cellInvDis = `AM${r}`;
    const cellPndAmt = `AN${r}`;
    const cellPndTax = `AO${r}`;
    const cellPndTotal = `AP${r}`;
    const formattedPrice = `${itemsData[r - 2].Unit_Price.toFixed(2)}`;
    const formattedAmount = `${itemsData[r - 2].Total_Amount.toFixed(2)}`;
    const formattedTaxPr = `${itemsData[r - 2].GST.toFixed(2)}`;
    const formattedTaxAmt = `${itemsData[r - 2].Tax_Amount.toFixed(2)}`;
    const formattedGross = `${itemsData[r - 2].Gross_Amount.toFixed(2)}`;
    const formatted_HC = `${itemsData[r - 2].Handling_Charges.toFixed(2)}`;
    const formatted_PC = `${itemsData[r - 2].Packing_Charges.toFixed(2)}`;
    const formatted_CC = `${itemsData[r - 2].Courier_Charges.toFixed(2)}`;
    const formatted_PGC = `${itemsData[r - 2].Payment_Gateway_Charges.toFixed(2)}`;
    const formattedInvAmt = `${itemsData[r - 2].Invoice_Amount.toFixed(2)}`;
    const formattedInvTax = `${itemsData[r - 2].Invoice_Tax_Amount.toFixed(2)}`;
    const formattedInvTotal = `${itemsData[r - 2].Invoice_Total_Amount.toFixed(2)}`;
    const formattedInvDis = `${itemsData[r - 2].Invoice_Discount.toFixed(2)}`;
    const formattedPndAmt = `${itemsData[r - 2].Pending_Amount.toFixed(2)}`;
    const formattedPndTax = `${itemsData[r - 2].Pending_Tax_Amount.toFixed(2)}`;
    const formattedPndTotal = `${itemsData[r - 2].Pending_Total_Amount.toFixed(2)}`;
    ws[cellPrice] = { t: 'n', v: formattedPrice, z: '#,##0.00' };
    ws[cellAmount] = { t: 'n', v: formattedAmount, z: '#,##0.00' };
    ws[cellTaxPr] = { t: 'n', v: formattedTaxPr, z: '#,##0.00' };
    ws[cellTaxAmt] = { t: 'n', v: formattedTaxAmt, z: '#,##0.00' };
    ws[cellGross] = { t: 'n', v: formattedGross, z: '#,##0.00' };
    ws[cellHC] = { t: 'n', v: formatted_HC, z: '#,##0.00' };
    ws[cellPC] = { t: 'n', v: formatted_PC, z: '#,##0.00' };
    ws[cellCC] = { t: 'n', v: formatted_CC, z: '#,##0.00' };
    ws[cellPGC] = { t: 'n', v: formatted_PGC, z: '#,##0.00' };
    ws[cellInvAmt] = { t: 'n', v: formattedInvAmt, z: '#,##0.00' };
    ws[cellInvTax] = { t: 'n', v: formattedInvTax, z: '#,##0.00' };
    ws[cellInvTotal] = { t: 'n', v: formattedInvTotal, z: '#,##0.00' };
    ws[cellInvDis] = { t: 'n', v: formattedInvDis, z: '#,##0.00' };
    ws[cellPndAmt] = { t: 'n', v: formattedPndAmt, z: '#,##0.00' };
    ws[cellPndTax] = { t: 'n', v: formattedPndTax, z: '#,##0.00' };
    ws[cellPndTotal] = { t: 'n', v: formattedPndTotal, z: '#,##0.00' };
    }
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'OrderDetailExport.xlsx');
}

const getInvoiceInfoByProductID = (productId: number, orderInvoice: any) => {
    const sortedInvoices = [...orderInvoice].sort((a, b) => new Date(b.invoicedDate).getTime() - new Date(a.invoicedDate).getTime());
   
    for (const inv of sortedInvoices) {
        if (inv.orderInvoiceDetail?.some((item: any) => item.productID === productId)) {
            return {
                invoiceNo: inv.invoiceNo,
                invoiceDate: inv.invoicedDate
            };
        }
    }
    return { invoiceNo: "", invoiceDate: "",filterOrders:"" };
}
 

const itemWiseData = (orderList : OrderModel[], flagReasons: Map<number, string>) => {
    var flatData: any = [];
    orderList?.forEach((order) => {
        order.orderDetail.forEach((product, index)=> {
            let invQty = product.quantity - product.pendingQuantity;
            let invAmt = invQty * product.unitPrice;
            let invTax = invAmt * product.gst/100;
            let pndQty = product.pendingQuantity>0 ? product.pendingQuantity : 0;
            let pndAmt = pndQty * product.unitPrice;
            let pndTax = pndAmt * product.gst/100;    
            const { invoiceNo, invoiceDate } = getInvoiceInfoByProductID(product?.productID, order.orderInvoice);  
            flatData.push({ 
                'Order#': order.orderID,
                'Bin No': order.packingNo ? order.packingNo : 0,
                'Order Date': new Date(order.createdDate).toLocaleDateString('en-gb'),
                'Order Status': order.orderStatusName,
                'Invoice#': invoiceNo,
                'Invoice Date': invoiceDate ? new Date(invoiceDate).toLocaleDateString('en-gb') : "",
                 'User Name': order.userName,
                'Mobile#': order.primaryContactNbr,
                'Address': order.address1 + " " + order.address2 + " " + order.landmark + " Pin-" + order.zipcode,
                'Area': order.areaName,
                'SubDistrict': order.subDistrictName,
                'District': order.districtName,
                'State': order.stateName,
                'Country': order.countryName,
                'PinCode': order.zipcode,
                'Route Code': order.routeCodeName,
                'GPS Location': order.gpsLocation,
                'GST #': order.gsT_Number,
                'Main Category': product.categoryName,
                'Sub Category': product.subCategoryName,
                'HSN Code': product.hsN_Code,
                'Product Name': product.productName,
                'Unit_Price': product.unitPrice,              
                'Order Qty': product.quantity,
                'Invoice Qty': invQty,
                'Pending Qty': pndQty,
                'UOM': product.measurementTypeName,
                'Total_Amount': product.taxableAmount,
                'GST': product.gst,
                'Tax_Amount': product.taxAmount,
                'Gross_Amount': Math.round(product.grossAmount),
                'Handling_Charges': 0,
                'Packing_Charges': 0,
                'Courier_Charges': order.courierCharges,
                'Payment_Gateway_Charges': 0,
                'Invoice_Amount': invAmt,
                'Invoice_Tax_Amount': invTax,
                'Invoice_Total_Amount': Math.round(invAmt + invTax),
                'Invoice_Discount': (order.orderInvoice.length>0) ? order.orderInvoice[0].discountAmount : 0,
                'Pending_Amount': pndAmt,
                'Pending_Tax_Amount': pndTax,
                'Pending_Total_Amount': pndAmt + pndTax,
                'Courier Provider': order.courierProviderName,
                'Tracking #': product.trackingID,
                'Order Payment Type': order.paymentModeName,
                'Payment Status': order.orderInvoice[0].paymentModeID === 1 ? "Success" : order.paymentStatus,
                'Bank Ref #': (order.orderInvoice.length>0) ? order.orderInvoice[0].bankRefNo : "",
                'Actual Payment Type': (order.orderInvoice.length>0) ? order.orderInvoice[0].paymentModeName : "",
                'Ordered Usename': order.createdUserName,
                'Ordered Contact': order.createdPrimaryContactNbr,
                'Invoiced Usename': (order.orderInvoice.length>0) ? order.orderInvoice[0].invoicedUserName : "",
                'Invoiced Contact': (order.orderInvoice.length>0) ? order.orderInvoice[0].invoicedPrimaryContactNbr : "",
                'Reason For Flag': flagReasons.get(order.customerID) ?? "",
            })
        })
    });
    return flatData;
}

export const invoiceExport = (orderList : OrderModel[]) => {
    const orderData = invoiceData(orderList);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);

    ws['D'] = { t: 's', v: 'Total Value', s: { font: { bold: true } } };
    ws['E'] = { t: 's', v: 'Handling charges', s: { font: { bold: true } } };
    ws['F'] = { t: 's', v: 'Courier charges', s: { font: { bold: true } } };
    ws['G'] = { t: 's', v: 'Packing charges', s: { font: { bold: true } } };
    ws['H'] = { t: 's', v: 'Payment gateway charges', s: { font: { bold: true } } };
    ws['I'] = { t: 's', v: 'Discount amount', s: { font: { bold: true } } };
    ws['J'] = { t: 's', v: 'Gross amount', s: { font: { bold: true } } };
    
    for (let r = 2; r <= orderData.length + 1; r++) {
        const cellTotal = `D${r}`;
        const cellHandling = `E${r}`;
        const cellCourier = `F${r}`;
        const cellPacking = `G${r}`;
        const cellPaymentGateway = `H${r}`;
        const cellDiscount = `I${r}`;
        const cellGross = `J${r}`;
        const formattedTotal = `${orderData[r - 2].Total_Value.toFixed(2)}`;
        const formattedHandling = `${orderData[r - 2].Handling_charges.toFixed(2)}`;
        const formattedCourier = `${orderData[r - 2].Courier_charges.toFixed(2)}`;
        const formattedPacking = `${orderData[r - 2].Packing_charges.toFixed(2)}`;
        const formattedPaymentGC = `${orderData[r - 2].Payment_gateway_charges.toFixed(2)}`;
        const formattedDiscount = `${orderData[r - 2].Discount_amount.toFixed(2)}`;
        const formattedGross = `${orderData[r - 2].Gross_amount.toFixed(2)}`;
        ws[cellTotal] = { t: 'n', v: formattedTotal, z: '#,##0.00' };
        ws[cellHandling] = { t: 'n', v: formattedHandling, z: '#,##0.00' };
        ws[cellCourier] = { t: 'n', v: formattedCourier, z: '#,##0.00' };
        ws[cellPacking] = { t: 'n', v: formattedPacking, z: '#,##0.00' };
        ws[cellPaymentGateway] = { t: 'n', v: formattedPaymentGC, z: '#,##0.00' };
        ws[cellDiscount] = { t: 'n', v: formattedDiscount, z: '#,##0.00' };
        ws[cellGross] = { t: 'n', v: formattedGross, z: '#,##0.00' };
    }
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'InvoiceListExport.xlsx');
}

const invoiceData = (orderList : OrderModel[]) => {
    var flatData: any = [];
    orderList?.forEach((order) => {
        if(order.orderInvoice.length>0) {
            order.orderInvoice?.forEach((invoice)=> {                
                flatData.push({
                    'Order#': order.orderID,                    
                    'Invoice#': invoice.invoiceNo,
                    'Invoice Date': new Date(invoice.invoicedDate).toLocaleDateString('en-gb'),
                    'Total_Value': Math.round(invoice.taxableAmount + invoice.taxAmount),
                    'Handling_charges': 0,
                    'Courier_charges': order.courierCharges,
                    'Packing_charges': 0,
                    'Payment_gateway_charges': 0,
                    'Discount_amount': invoice.discountAmount,
                    'Gross_amount': invoice.grossAmount
                })
            })
        }       
    });
    return flatData;
}

export const invoiceDetailExport = (orderList : OrderModel[]) => {
    const orderData = invoiceDetailData(orderList);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);

    ws['D'] = { t: 's', v: 'Total Value', s: { font: { bold: true } } };
    ws['E'] = { t: 's', v: 'Handling charges', s: { font: { bold: true } } };
    ws['F'] = { t: 's', v: 'Courier charges', s: { font: { bold: true } } };
    ws['G'] = { t: 's', v: 'Packing charges', s: { font: { bold: true } } };
    ws['H'] = { t: 's', v: 'Payment gateway charges', s: { font: { bold: true } } };
    ws['I'] = { t: 's', v: 'Discount amount', s: { font: { bold: true } } };
    ws['J'] = { t: 's', v: 'Gross amount', s: { font: { bold: true } } };
    
    for (let r = 2; r <= orderData.length + 1; r++) {
        const cellTotal = `D${r}`;
        const cellHandling = `E${r}`;
        const cellCourier = `F${r}`;
        const cellPacking = `G${r}`;
        const cellPaymentGateway = `H${r}`;
        const cellDiscount = `I${r}`;
        const cellGross = `J${r}`;
        const formattedTotal = `${orderData[r - 2].Total_Value.toFixed(2)}`;
        const formattedHandling = `${orderData[r - 2].Handling_charges.toFixed(2)}`;
        const formattedCourier = `${orderData[r - 2].Courier_charges.toFixed(2)}`;
        const formattedPacking = `${orderData[r - 2].Packing_charges.toFixed(2)}`;
        const formattedPaymentGC = `${orderData[r - 2].Payment_gateway_charges.toFixed(2)}`;
        const formattedDiscount = `${orderData[r - 2].Discount_amount.toFixed(2)}`;
        const formattedGross = `${orderData[r - 2].Gross_amount.toFixed(2)}`;
        ws[cellTotal] = { t: 'n', v: formattedTotal, z: '#,##0.00' };
        ws[cellHandling] = { t: 'n', v: formattedHandling, z: '#,##0.00' };
        ws[cellCourier] = { t: 'n', v: formattedCourier, z: '#,##0.00' };
        ws[cellPacking] = { t: 'n', v: formattedPacking, z: '#,##0.00' };
        ws[cellPaymentGateway] = { t: 'n', v: formattedPaymentGC, z: '#,##0.00' };
        ws[cellDiscount] = { t: 'n', v: formattedDiscount, z: '#,##0.00' };
        ws[cellGross] = { t: 'n', v: formattedGross, z: '#,##0.00' };
    }
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'InvoiceDetailExport.xlsx');
}

const invoiceDetailData = (orderList : OrderModel[]) => {
    var flatData: any = [];
    orderList?.forEach((order) => {
        if(order.orderInvoice.length>0) {
            order.orderInvoice?.forEach((invoice)=> {
                invoice.orderInvoiceDetail?.forEach((item)=> {
                    flatData.push({
                        'Order#': order.orderID,                 
                        'Invoice#': invoice.invoiceNo,
                        'Invoice Date': new Date(invoice.invoicedDate).toLocaleDateString('en-gb'),                        
                        'Total_Value': Math.round(invoice.taxableAmount + invoice.taxAmount),
                        'Handling_charges': 0,
                        'Courier_charges': order.courierCharges,
                        'Packing_charges': 0,
                        'Payment_gateway_charges': 0,
                        'Discount_amount': invoice.discountAmount,
                        'Gross_amount': invoice.grossAmount,
                        'Product Name': item.productName,
                        'Measurment Unit': item.measurementTypeCode,
                        'Quantity': item.invoicedQuantity,
                        'Total_amount': Math.round(item.totalAmount)
                    })
                })
            })
        }       
    });
    return flatData;
}